import styled, { css } from 'styled-components';

import Button from '../Button/Button';
import { iconSizes, tagConsts } from './Tag.consts';
import { TagIconPosition, ITagProps, TagSize } from './Tag.types';

type StyledLabelProps = {
  size: TagSize;
  iconPosition: TagIconPosition;
  $haveIcon: boolean;
};

type StylePropsRequired = 'size' | 'subtle' | 'shape' | 'color';
const Tag = styled.div<Required<Pick<ITagProps, StylePropsRequired>>>`
  display: flex;
  align-items: center;
  width: fit-content;
  background-color: ${({ theme, color, subtle }) => theme.system[subtle ? 'subtle' : 'strong'][color]};
  min-height: ${({ size }) => tagConsts.minHeight[size]};
  padding: ${({ shape, size }) => tagConsts.padding.container[shape][size]};
  border-radius: ${({ shape, size }) => tagConsts.radius[shape][size]};
  color: ${({ theme, color, subtle }) => theme.text.onSystem[subtle ? 'subtle' : 'strong'][color]};

  svg {
    width: ${({ size }) => iconSizes[size]};
    height: ${({ size }) => iconSizes[size]};

    path {
      fill: ${({ theme, color, subtle }) => theme.text.onSystem[subtle ? 'subtle' : 'strong'][color]};
    }
  }
`;

const Label = styled.span<StyledLabelProps>`
  ${({ theme, size }) => css`
    ${size === 'large' && theme.label.large.bold}
    ${size === 'medium' && theme.label.medium.bold}
    ${size === 'small' && theme.label.small.bold}
    padding: ${tagConsts.padding.label[size]};
  `};
`;

const TagButton = styled(Button)`
  padding: 0;
  margin-left: 4px;
  width: auto;
  height: auto;
  min-height: auto;
  border: none;
`;

export { Tag, Label, TagButton };
